import React, { useEffect, useRef, useState } from 'react'
import { Column } from 'primereact/column'
import TipoOperacaoFiscalService from "./tipoOperacaoFiscalService"
import FormList from 'base/FormList'

export default function TipoOperacaoFiscalList() {

    const [service] = useState(() => new TipoOperacaoFiscalService())
    const toast = useRef(null)
    const searchData = {
        pkName: 'codigo_tiof',
        dsName: 'descricao_tiof',
        mainField: { name: 'descricao_tiof', label: 'Descrição' },
        advFields: [
            { name: 'codigo_tiof', label: 'Código', type: 'integer', inputMode: 'numeric' },
            { name: 'descricao_tiof', label: 'Descrição', type: 'string', inputMode: 'text' },
        ]
    }

    useEffect(() => {
    }, [service])

    return (
        <FormList service={service} toast={toast} searchData={searchData} showActions={true}>
            <Column field="codigo_tiof" sortable header="Código"></Column>
            <Column field="descricao_tiof" sortable header="Descrição"></Column>
        </FormList >
    )
}
